import { render, staticRenderFns } from "./listado_de_usuarios_por_bandeja.vue?vue&type=template&id=c972a2e0"
import script from "./listado_de_usuarios_por_bandeja.vue?vue&type=script&lang=js"
export * from "./listado_de_usuarios_por_bandeja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports